import styled from 'styled-components';
import { Radio } from 'antd';

export const RadioStyled = styled(Radio)`
  font-family: 'inter-regular', sans-serif;
  color: var(--FORM-LABEL-default);
  font-size: 14px;
`;
